































import mixins from 'vue-typed-mixins';
import NotificationEmitter from '@/components/NotificationEmitter.vue';
import S3Mixin from '@/components/mixins/s3';

export default mixins(S3Mixin).extend({
  components: {
    NotificationEmitter,
  },
});
